import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function AddGroupsIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M11.2 14V8.333m-2.8 2.834H14M8 9.333H5.6c-1.118 0-1.677 0-2.118.186a2.42 2.42 0 0 0-1.3 1.323C2 11.292 2 11.861 2 13m8.1-10.822c.88.362 1.5 1.24 1.5 2.266s-.62 1.905-1.5 2.267M8.9 4.444c0 1.35-1.075 2.445-2.4 2.445S4.1 5.794 4.1 4.444 5.175 2 6.5 2s2.4 1.094 2.4 2.444" /></svg>
  );
}

export default AddGroupsIcon;
